import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { EmailcontentService } from '../../../services/emailcontent.service';
import { FileHelper } from 'src/app/helpers/files/file.helper';
import { EmailTemplateGeneratorService, TemplateAData } from 'src/app/services/email-template-generator.service';

@Component({
    selector: 'app-email-templates-edit',
    styleUrls: ['./email-templates-edit.component.scss'],
    templateUrl: './email-templates-edit.component.html'
})
export class EmailTemplatesEditComponent implements OnInit {
    @ViewChild('fileUpload') fileUploadName;
    public id: any;
    public pageTitle = 'Edit Email Template';
    public emailTemplateForm: UntypedFormGroup;
    public emailTemplate: any;
    public canSave: boolean = true;
    public isSaving = false;
    public hasSaved = false;
    public isSaveQueued = false;

    public fileManagerSettings
    FileManagerSettingsModel
    theFile: any;
    isUploadingFile: boolean;
    fileName: any = "";
    isUploadButtonDisabled: boolean = true;

    // Template type support
    public isTemplateA: boolean = false;
    public parsedTemplateJson: TemplateAData;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private emailContentService: EmailcontentService,
        private fileHelper: FileHelper,
        private emailTemplateGenerator: EmailTemplateGeneratorService
    ) {

    }
    async ngOnInit() {
        // Check for passed in id
        this.id = this.route.snapshot.paramMap.get('id');
        this.emailTemplate = await this.emailContentService
            .get({ oid: this.id })
            .toPromise();

        // A Structured template with no layout (as the Blazor app writes them) is the whole email as authored;
        // giving it the default layout here would make the next save send the empty TemplateA shell instead.
        this.isTemplateA = this.emailTemplate.templateType === 1 && !!this.emailTemplate.templateJSON;
        if (this.isTemplateA) {
            this.parsedTemplateJson = this.emailTemplateGenerator.parseTemplateJson(this.emailTemplate.templateJSON);
        }

        this.emailContentService.getFileAttachmentName(
            this.id).subscribe((data: any) => {
                this.fileName = data;
            });
    }
    public onselected(e) {
        // Specify the image name
        e.filesData[0].name = "RTEImage changes";
    }


    public cancelEmailTemplateEdit(): void {
        this.router
            .navigate(['/default-layout/email-templates/'])
            .then(() => {});
    }

    public formChanged(event): void {
        if (this.canSave)
            this.saveEmailTemplate();
    }

    /**
     * Handle template JSON changes from TemplateA editor
     */
    public onTemplateJsonChange(newJson: TemplateAData): void {
        this.parsedTemplateJson = newJson;
        this.emailTemplate.templateJSON = JSON.stringify(newJson);

        // Generate HTML from template
        this.emailTemplate.emailContentHtml = this.emailTemplateGenerator.generateTemplateAHtml(newJson);

        // Save changes
        if (this.canSave) {
            this.saveEmailTemplate();
        }
    }

    /**
     * Get template type display name
     */
    public getTemplateTypeName(): string {
        if (this.emailTemplate?.templateType === 1) {
            return this.isTemplateA ? 'TemplateA' : 'Structured';
        }
        return 'Custom';
    }

    onFileChange(event) {
        if(!this.fileHelper.isValidImageSize(event.srcElement.files[0].size)){
            this.isUploadButtonDisabled = true;
            return;
        }
        this.isUploadButtonDisabled = false;
        this.theFile = null;
        if (event.target.files && event.target.files.length > 0) {
            // Set theFile property
            this.theFile = event.target.files[0];
        }
    }

    uploadFile(): void {
        if (this.theFile != null) {
            this.isUploadingFile = true;
            this.readAndUploadFile(this.theFile);
        }
    }
    deleteFile(): void {
        this.emailContentService
            .deleteFileAttachment(this.id)
            .subscribe((data: any) => {
                this.fileName = '';
            });
    }

    downloadFile(): void {
        this.emailContentService.downloadFileAttachment(this.id).subscribe((data: any) => {
            const source = data;
            const link = document.createElement("a");
            link.href = source;
            link.download = this.fileName;
            link.click();
        });
    }

    // Private Methods
    private saveEmailTemplate() {
        if (this.canSave) {
            const self = this;
            if (this.isSaving) {
                // Save already in queue - no need to double-up the queue
                if (this.isSaveQueued) {
                    return;
                }
                this.isSaveQueued = true;
                setTimeout(() => {
                    self.saveEmailTemplate();
                }, 250);
                return;
            }

            this.isSaveQueued = false;
            this.isSaving = true;
            this.hasSaved = false;

            this.emailContentService
                .update(this.emailTemplate)
                .subscribe((response: any) => {
                    this.isSaving = false;
                    this.hasSaved = true;
                });
        }
    }

    private readAndUploadFile(theFile: any) {
        const file = {
            ContentType: theFile.type,

            EmailContentId: this.id,

            FileData: null,
            // Set File Information
            FileName: theFile.name,
        };

        var printEventType = function (event) {
            var error = event;
        };

        // Use FileReader() object to get file to upload
        // NOTE: FileReader only works with newer browsers
        const reader = new FileReader();

        // Setup onload event for reader
        reader.onload = () => {
            // Store base64 encoded representation of file
            file.FileData = reader.result.toString();

            // POST to server
            this.emailContentService.uploadFileAttachment(file).subscribe((data: any) => {
                if (data.indexOf("Message:") < 1) {
                    this.isUploadingFile = false;
                    this.fileUploadName.nativeElement.value = '';
                    this.fileName = theFile.name;
                }
            });
        }

        // Read the file
        reader.readAsDataURL(theFile);
        reader.onerror = printEventType;
    }
}
